@if (message(); as htmlMessage) {
    <div class="login-duration" [ngClass]="{ 'login-duration-txt-empty': isDurationTextHidden() }">
        <span class="login-duration-text" [vnDynamicHtml]="htmlMessage"></span>
    </div>
}
